import React, { useEffect } from "react";
import "./Cutting_Edge.css";
import Common_Title_2 from "../../common_components/common_title_2/Common_Title_2";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { getcuttingedge } from "../../../features/home/homeSlice";
import { useDispatch, useSelector } from "react-redux";

const Cutting_Edge = () => {
  const data = [
    {
      title: "Aero Sleep Technology",
      descn:
        "Every Majesty mattress is crafted with built-in climate control, ensuring a steady stream of fresh air for a perfectly cool and breathable night.",
      img: "/assets/images/home/cutting_edge/img1.png",
    },
    {
      title: "Aero Sleep Technology",
      descn:
        "Every Majesty mattress is crafted with built-in climate control, ensuring a steady stream of fresh air for a perfectly cool and breathable night.",
      img: "/assets/images/home/cutting_edge/img1.png",
    },
    {
      title: "Aero Sleep Technology",
      descn:
        "Every Majesty mattress is crafted with built-in climate control, ensuring a steady stream of fresh air for a perfectly cool and breathable night.",
      img: "/assets/images/home/cutting_edge/img1.png",
    },
  ];

  const cuttingedge = useSelector((state) => state?.home?.cuttingedge);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getcuttingedge());
  }, []);

  return (
    <section className="Cutting_Edge">
      <div className="container">
        <Common_Title_2
          title={"Cutting-Edge Innovation for Superior Rest"}
          subtitle={
            "Explore the science of comfort through our research-backed mattresses and sleep essentials."
          }
        />

        <div className="swiper_div">
          <Swiper
            spaceBetween={30}
            pagination={{
              dynamicBullets: true,
              clickable: true,
            }}
            autoplay={{
              delay: 3000, // 3 seconds
              disableOnInteraction: false, // keeps autoplay after swipe
            }}
            modules={[Pagination, Autoplay]}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 10 },
            }}
            className="common_swiper"
          >
            {cuttingedge?.filter(item => item?.status !== false)
            ?.map((item) => (
              <SwiperSlide>
                <div className="blue_box">
                  <div className="content_div">
                    <p className="title_text">{item?.name}</p>
                    <p className="descn_text">{item?.description}</p>
                  </div>
                  <div className="right_img_div">
                    <img
                      src={process.env.REACT_APP_IMG_URL +  item?.image}
                      className="right_img"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Cutting_Edge;
